import { useMemo } from 'react'
import type { Bloco, BlocoKanbanColumn } from '@/types/bloco'
import { resolveBlocoDisplayColumnId } from './blocosKanbanUtils'

function sortBlocos(items: Bloco[]): Bloco[] {
  return [...items].sort((a, b) => {
    const orderDiff = (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
    if (orderDiff !== 0) return orderDiff
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  })
}

export function useBlocosByColumn(
  blocos: Bloco[],
  columns: BlocoKanbanColumn[],
  viewerId: string | undefined,
  labelFilterId?: string | null,
) {
  return useMemo(() => {
    const filtered = labelFilterId
      ? blocos.filter((b) => b.labels?.some((label) => label.id === labelFilterId))
      : blocos

    const map = new Map<string, Bloco[]>()
    for (const column of columns) {
      map.set(column.id, [])
    }

    for (const bloco of filtered) {
      const columnId = resolveBlocoDisplayColumnId(bloco, viewerId, columns)
      const list = map.get(columnId) ?? []
      list.push(bloco)
      map.set(columnId, list)
    }

    for (const column of columns) {
      map.set(column.id, sortBlocos(map.get(column.id) ?? []))
    }

    return map
  }, [blocos, columns, viewerId, labelFilterId])
}
